import React from 'react'
import '../../assets/styles/cards.css';
import { TiGroupOutline } from "react-icons/ti";
import { useEffect, useState } from 'react';
import { color } from 'motion';
import { TbVectorBezierCircle } from "react-icons/tb";
import { MdOutlineProductionQuantityLimits } from "react-icons/md";
import { useViewCardsReport } from '../../hooks/reports/cards';


const Cards = () => {

    const { data, loading, error } = useViewCardsReport();

    console.log("cards data", data);

    const dashboardCards = [
 
        {
            title: 'Distributors Count',
            value: data?.data?.totalDistributors || 0,
            icon: <TbVectorBezierCircle />,
            color: '#047857',
            bgColor: '#10b98176',
            link: '/distributorsList'
        
        },
               {
            title: 'Total Admin Users',
            value: data?.data?.totalUsers || 0,
            icon: <TiGroupOutline />,
            color: '#06538a',
            bgColor: '#0b80d376',
            link : '/AdminUserList'
        },
        {
            title: 'Product Count',
            value: data?.data?.totalProducts || 0,
            icon: <MdOutlineProductionQuantityLimits />,
            color: '#b40909',
            bgColor: '#b409096c',
            link: '/products/productList'
        },
        
    ]
  return (
    <>
        <div className="cards-container">
            <div className="card-body">
                {dashboardCards.map((card, index) => (
                    <div className="cardItem" key={index} onClick={card.link ? () => window.location.href = card.link : null} style={{cursor: card.link ? 'pointer' : 'default'}}>
                        <p style={{fontSize: '2rem', margin: '0', color: card.color || '#0b80d3', background: card.bgColor || '#0b80d376', width:'fit-content', width:'40px',height:'40px', borderRadius: '5px',margin:'10px auto'}}>{card.icon}</p>
                        <h3>{card.title}</h3>
                        <p className="value">{card.value}</p>
                        <p className="description">{card.description}</p>
                    </div>
                ))}
            </div>
        </div>
    </>
  )
}

export default Cards